module.exports = __webpack_public_path__ + "img/circle_01_focus2.8f1165f8.svg";